import React from 'react';

import Link from '../../../../../../library/link/link';
import Typography from '../../../../../../library/typography/typography';
import Price from '../../../../../../components/price/price';
import ProductImage from '../../../../../../components/product-image/product-image';
import TopThreeTileHeader from '../top-three-tile-header/top-three-tile-header';

import { PriceInfoProps } from '../../../../../../shared/types/product';
import { PRODUCT_TILE_TYPES } from '../../../../../../shared/constants/treadwell';

import './top-three-tile.scss';

const MESSAGES = {
  [PRODUCT_TILE_TYPES.RECOMMENDED]:
    'We recommend these tires based on extensive performance and safety testing, and overall value.',
  [PRODUCT_TILE_TYPES.HIGHEST_RATED]:
    'These tires have the most positive reviews from our customers.',
  [PRODUCT_TILE_TYPES.ORIGINAL_EQUIPMENT]:
    'These are the tires your vehicle is equipped with from the factory.',
  [PRODUCT_TILE_TYPES.BEST_SELLER]:
    'Our customers purchase these tires most often.'
};

interface TopThreeTileProps {
  brand?: string;
  code?: string;
  detailsLink?: string;
  imageUrl?: string;
  name?: string;
  onViewDetailsClick?: (value: string) => void;
  position?: number;
  priceInfo?: PriceInfoProps;
  priceSubtext?: string;
  rank?: number;
  rearCode?: string;
  rearPriceInfo?: PriceInfoProps;
  type: typeof PRODUCT_TILE_TYPES[keyof typeof PRODUCT_TILE_TYPES];
  unitName?: string;
}

//TODO: Attempt to use ProductTile to make TopThreeTile and SuggestedSellingTile consistent
function TopThreeTile(props: TopThreeTileProps) {
  const {
    brand,
    detailsLink = '',
    priceInfo,
    priceSubtext,
    rearPriceInfo,
    name,
    onViewDetailsClick,
    imageUrl,
    rank,
    rearCode,
    type,
    unitName
  } = props;

  const isTreadwell = Boolean(rank && rank > 0);
  const infoMessage = MESSAGES[type] || '';
  const { price, mapPrice, priceRange } = priceInfo || {};
  const {
    price: rearPrice,
    mapPrice: rearMapPrice,
    priceRange: rearPriceRange
  } = rearPriceInfo || {};

  return (
    <div styleName={rearCode ? 'staggered-tile' : 'tile'}>
      <div styleName="inner-tile">
        <TopThreeTileHeader
          infoMessage={infoMessage}
          isTreadwell={isTreadwell}
          rank={rank}
          type={type}
        />
        <Link
          onClick={() =>
            onViewDetailsClick?.(
              `product_list_attribute_top_3_${type?.toLowerCase()}`
            )
          }
          styleName="container-link"
          to={detailsLink}
        >
          <div styleName="tile-content">
            {imageUrl && !rearCode && (
              <ProductImage
                ariaLabel={name}
                className="top-three-product-image"
                height={92}
                imageUrl={imageUrl}
                width={92}
              />
            )}
            <div styleName="text-container">
              <div styleName="brand-name-container">
                <Typography
                  size="extraSmall"
                  styleName="brand"
                  tag="span"
                  weight="black"
                >
                  {brand}
                </Typography>
                <Typography styleName="name" tag="span" weight="black">
                  {name}
                </Typography>
              </div>
              <div styleName="tile-summary">
                <span styleName="price-container">
                  <Typography
                    size="small"
                    styleName={rearCode ? 'staggered-price' : 'price'}
                    tag="span"
                  >
                    {rearCode && <span styleName="price-label">Front:</span>}
                    {price && (
                      <Price
                        className="price"
                        mapPrice={mapPrice}
                        price={price}
                        priceRange={priceRange}
                        unitName={unitName}
                      />
                    )}
                  </Typography>
                  {rearCode && rearPrice && (
                    <Typography
                      size="small"
                      styleName="staggered-price-rear"
                      tag="span"
                    >
                      <span styleName="price-label">Rear:</span>
                      <Price
                        className="price"
                        mapPrice={rearMapPrice}
                        price={rearPrice}
                        priceRange={rearPriceRange}
                        unitName={unitName}
                      />
                    </Typography>
                  )}
                </span>
                {priceSubtext && (
                  <Typography
                    size="extraSmall"
                    styleName="price-subtext"
                    tag="span"
                  >
                    {priceSubtext}
                  </Typography>
                )}

                {detailsLink && (
                  <Typography
                    size="small"
                    styleName="view-details"
                    tag="span"
                    weight="heavy"
                  >
                    View Details
                  </Typography>
                )}
              </div>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default TopThreeTile;
